export default class MissingVariantError extends Error {
};
